import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: '1rem',
    fontWeight: 400,
  },
  saving: {
    paddingTop: 0,
    marginLeft: pxToRem(10),
  },
});
